module.exports = __webpack_public_path__ + "img/dazhong.ebea7343.png";